import XApi from '../../utils/Api';
import XEndpoints from '../../core/config/Endpoints';

export class UserService {
    async createRole({ name, modules }: {
        name: string,
        modules: any[],
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.role, {
                name,
                modules,
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateRole({ id, name, modules, status, deleted }: {
        id: number,
        name?: string,
        modules?: any[],
        status?: string,
        deleted?: boolean,
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.role}/${id}`, {
                ...(name && { name }),
                ...(modules && { modules }),
                ...(status && { status }),
                ...(deleted && { deleted }),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async getRole(id: string) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.role}/${id}`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async allRoles() {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.role}/all`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async createUser({ name, email, password, phoneNumber, profilePic, role }: {
        name: string,
        email: string,
        password: string,
        phoneNumber?: string,
        profilePic?: string,
        role?: string,
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.post(XEndpoints.user, {
                name,
                email,
                password,
                ...(phoneNumber && { phoneNumber }),
                ...(profilePic && { profilePic }),
                ...(role && { role }),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async updateUser({ id, name, email, password, phoneNumber, profilePic, role, status, deleted }: {
        id: number,
        name?: string,
        email?: string,
        password?: string,
        phoneNumber?: string,
        profilePic?: string,
        role?: string,
        status?: string,
        deleted?: boolean,
    }) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.user}/detail/${id}`, {
                ...(name && { name }),
                ...(email && { email }),
                ...(password && { password }),
                ...(phoneNumber && { phoneNumber }),
                ...(profilePic && { profilePic }),
                ...(role && { role }),
                ...(status && { status }),
                ...(deleted && { deleted }),
            }, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }

    async getUser(id: string) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.get(`${XEndpoints.user}/detail/${id}`, {
                'Content-Type': 'application/json',
                'Authorization': token,
            });
            return response ?? null;
        }
        return null;
    }
}
